module.exports = __webpack_public_path__ + "static/media/jade.d9d210ca.png";